import React, { memo } from 'react';
import styled from 'styled-components';
import { Flex, Card } from '../primitives';
import SavedSearches, { SavedSearchesLoadingFallback } from '../SavedSearches';
import Boundary from '../Boundary';

const OuterContainer = styled(Flex)`
  padding-bottom: 20px;
  border-top: 1px solid #ebeaea;
`;

function SavedSearchesWidgetContent() {
  return (
    <Flex direction="column" fill>
      <h6 className="section-header widget">Saved Searches</h6>
      <OuterContainer direction="column" fill>
        <Card
          padding="0"
          direction="column"
          borderRadius={false}
          boxShadow={false}
          border={false}
          fill
        >
          <SavedSearches showDeleteButton={false} borderTop={false} />
        </Card>
      </OuterContainer>
    </Flex>
  );
}

const SavedSearchesWidget = () => {
  return (
    <Boundary fallback={null} loadingFallback={<SavedSearchesLoadingFallback />}>
      <SavedSearchesWidgetContent />
    </Boundary>
  );
};

export default memo(SavedSearchesWidget);
